module.exports = require("./lib/randomstring");


// WEBPACK FOOTER //
// ./~/randomstring/index.js